import { render } from "./textarea.vue?vue&type=template&id=28e35444"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/components/form/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28e35444"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28e35444', __exports__)) {
    console.log('reload')
    api.reload('28e35444', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=28e35444", () => {
    console.log('re-render')
    api.rerender('28e35444', render)
  })

}


export default __exports__